<template>
  <div v-if="isLoggedIn" class="mt-1">
    <v-tabs
      v-model="active"
      color="#ff2e2e"
      centered
      dark
      slider-color="indigo"
    >
      <v-tab
        v-for="(status, index) in statuses"
        :key="index"
        ripple
        @click="statusList(index + 1)"
      >
         {{ status.title }}
      </v-tab>
      <v-tab-item
        v-for="(status, index) in statuses"
        :key="index"
      >
        <v-card flat>
            <Processing v-if="status.status_id == 1 && active == 0" ></Processing>
            <Pending v-else-if="status.status_id == 2 && active == 1"></Pending>
            <Rejected v-else-if="status.status_id == 3 && active == 2"></Rejected>
            <Modify v-else-if="status.status_id == 4 && active == 3"></Modify>
            <Verified v-else-if="status.status_id == 5 && active == 4"></Verified>
            <PaidScheduled v-else-if="status.status_id == 7 && active == 6"/>
            <Ongoing v-else-if="status.status_id == 8 && active == 7"/>
            <Cancelled v-else-if="status.status_id == 9 && active == 8"/>
            <Pause v-else-if="status.status_id == 11 && active == 10"/>
            <OnHold v-else-if="status.status_id == 12 && active == 11"/>
            <Completed v-else-if="status.status_id == 13 && active == 12"/>
        </v-card>
      </v-tab-item>
    </v-tabs>

    <div class="text-xs-center mt-3">
      <button class="button" flat @click="next()">Next Tab</button>
    </div>
  </div>
  <div centered v-else>
    <v-container>
      <v-layout row wrap>
        <v-flex xs4 md4></v-flex>
        <v-flex xs4 md4 align-end>
          <v-card>
            <v-card-text color="indigo">
                You are not logged in!
            </v-card-text>
          </v-card>
          <router-link to="/signin">
            <v-btn color="#ff2e2e"><v-icon>lock_open</v-icon> login</v-btn>
          </router-link>
        </v-flex>
        <v-flex xs4 md4></v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Processing from './Processing'
import Pending from './Pending'
import Rejected from './Rejected'
import Verified from './Verified'
import Modify from './Modify'
import PaidScheduled from './PaidScheduled'
import Ongoing from './Ongoing'
import Pause from './Pause'
import OnHold from './OnHold'
import Completed from './Completed'
import Cancelled from './Cancelled'

import {mapGetters} from 'vuex'

  export default {
    data () {
      return {
        active: null,
        statusData:null,
        statuses:[
          { 'title':'processing', 'status_id':1},
          { 'title':'pending', 'status_id':2},
          { 'title':'rejected', 'status_id':3}, 
          { 'title':'required-for-modification', 'status_id':4},
          { 'title':'verified', 'status_id':5},
          { 'title':'paid-not-scheduled', 'status_id':6},
          { 'title':'paid scheduled', 'status_id':7}, 
          { 'title':'on going', 'status_id':8},
          { 'title':'cancel', 'status_id':9}, 
          { 'title':'stop', 'status_id':10}, 
          { 'title':'pause', 'status_id':11}, 
          { 'title':'on hold', 'status_id':12},
          { 'title':'completed', 'status_id':13}
        ]
      }
    },
    components: {
        Processing,
        Pending,
        Rejected,
        Verified,
        Modify,
        PaidScheduled,
        Ongoing,
        Pause,
        OnHold,
        Completed,
        Cancelled
    },
    computed:{
      ...mapGetters(['isLoggedIn', 'indexData', 'error', 'statusCode', 'errorMsg'])     
    },

    created () {
       this.statusList(1)
    },

    methods: {
      next () {
        // console.log(this.active)
        // const active = parseInt(this.statusData)
        // var statusId = active + 2
        // if(statusId > 13){
        //   statusId = 1
        // }
        if(this.statusData == 13){
          this.statusData = 1;
        }else{
          this.statusData = this.statusData + 1;
        }
        this.statusList(this.statusData)

        // this.active = (active < 12 ? active + 1 : 0);
        this.active = parseInt(this.statusData) - 1;
      },
      
      statusList: function(projectStatusId){
        // console.log(projectStatusId);
        this.$store.dispatch('changeProjectStatus', ['status-list', projectStatusId, '', 1, 5]);
         this.active = parseInt(projectStatusId) - 1;
        //  console.log(this.active);
         this.statusData = projectStatusId;
      }
    }
  }
</script>

<style lang="stylus" scoped>
.button {
  font-size: 16px;
  background: #ff2e2e;
  padding: 0.4rem 1.3rem;
  text-align: center;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  margin: 10px;
  color:white;
}
  
</style>